import {
    FaRunning,
    FaUserTie,
    FaTrophy,
    FaBuilding
} from "react-icons/fa"
import "./UniversitySports.css"
import Footer from "../../Footer/Footer"
import Navbar from "../../Navbar/Navbar"

const UniversitySports = () => {
    return (
        <>
            <Navbar />
            {/* ================= BANNER ================= */}
<div className="sports-banner">
  <img
    src="/campuslife/sports/sports1.jpeg"
    alt="Rayalaseema University Sports"
  />
  <div className="sports-banner-overlay">
    <h1>Sports & Physical Education</h1>
   
  </div>
</div>
            <section className="sports-section">
                <div className="sports-container">

                    {/* ================= HEADER ================= */}
                    <div className="sports-header">
                        <FaRunning className="sports-main-icon" />
                        <h1>Sports & Physical Education</h1>
                        <p>
                            Rayalaseema University promotes physical fitness, sportsmanship,
                            and holistic development of students through structured sports
                            and physical education programmes.
                        </p>
                    </div>

                    {/* ================= ABOUT SPORTS ================= */}
                    <div className="sports-about">
                        <h2><FaTrophy /> About Sports at Rayalaseema University</h2>

                        <p>
                            Rayalaseema University has a well-developed multipurpose playground
                            on the campus for outdoor games such as Cricket, Football,
                            Volleyball, and Athletics. The university also has an Indoor
                            Stadium with shuttle badminton courts and a fitness centre to
                            support indoor sports and physical training.
                        </p>

                        <p>
                            The University is a registered member of the Inter University Sports
                            Board of India. University teams regularly participate in South Zone
                            and All India Inter-University Tournaments. In addition, intercollegiate
                            sports and games are conducted frequently on the campus.
                        </p>

                        <p>
                            Coaching camps in various sports disciplines are organized
                            periodically in a congenial atmosphere, focusing on skill
                            development and competitive excellence among students.
                        </p>
                    </div>

                    {/* ================= COORDINATOR ================= */}
                    <div className="sports-coordinator">
                        <h2><FaUserTie /> Sports Coordinator</h2>

                        <div className="coordinator-card">
                            <div className="coordinator-info" style={{textAlign: 'center', width: '100%'}}>
                              <img src="/campuslife/sports/sports_coordinator.JPG" alt="" />
                                <h3>Dr. K. V. Siva Kishore</h3>
                                <p className="designation">
                                    Assistant Director of Physical Education (C)
                                </p>
                                <p>
                                    Department of Physical Education & Sports<br />
                                    Rayalaseema University, Kurnool
                                </p>

                                
                            </div>
                        </div>
                    </div>
                    {/* ================= TOURNAMENTS ================= */}
<div className="sports-tournaments">
  <h2><FaTrophy /> Tournaments Organized</h2>

  <h3>Inter-University Tournaments Hosted</h3>
  <ul>
    <li>
      <strong>2023–2024:</strong> Hosted All India Inter-University Sepak Takraw
      Men Championship (50 Universities participated – first time hosted)
    </li>
    <li>
      <strong>2021–2022:</strong> Hosted South Zone Inter-University Badminton
      Women Tournament (55 Universities participated – first time hosted)
    </li>
    <li>
      <strong>2018–2019:</strong> Hosted South Zone Inter-University Handball Men
      Tournament (65 Universities participated – first time hosted)
    </li>
  </ul>

  <h3>Inter-Collegiate Tournaments (On Campus)</h3>
  <ul>
    <li>
      <strong>2024–2025:</strong> Kabaddi, Handball & Sepak Takraw (Men)
      – 01-10-2024 to 02-10-2024
    </li>
    <li>
      <strong>2023–2024:</strong> Football, Sepak Takraw, Handball (Men) and
      Inter-Collegiate Athletic Meet (Men & Women)
    </li>
    <li>
      <strong>2022–2023:</strong> Cricket (Kurnool Zone), Football, Handball,
      Sepak Takraw, Athletic Meet (Men & Women)
    </li>
    <li>
      <strong>2021–2022:</strong> Athletics, Shuttle Badminton, Table Tennis
      (Men & Women)
    </li>
    <li>
      <strong>2019–2020:</strong> Athletics, Shuttle Badminton, Table Tennis
      (Men & Women)
    </li>
    <li>
      <strong>2016–2017:</strong> Inter-Collegiate Cricket – Kurnool & Central Zones
    </li>
    <li>
      <strong>2014–2015:</strong> Inter-Collegiate Athletics Championship
      (Men & Women)
    </li>
  </ul>
</div>
{/* ================= ACHIEVEMENTS ================= */}
<div className="sports-achievements">
  <h2><FaTrophy /> Major Achievements</h2>

  <ul>
    <li>
      <strong>2024–2025:</strong> University Badminton Women team secured
      2nd Runners-up in South Zone Inter-University Tournament and qualified
      for All India.
    </li>
    <li>
      <strong>2023–2024:</strong> Bronze Medal – All India Inter-University
      Sepak Takraw Men Championship.
    </li>
    <li>
      University Weight Lifter <strong>Mr. Shaik Abdullah</strong> secured
      Bronze Medal in South West Zone, All India & Khelo India University Games.
    </li>
    <li>
      <strong>2022–2023:</strong> Badminton player <strong>Miss M. Akanksha</strong>
      represented India at World University Games, Chengdu, China.
    </li>
    <li>
      Badminton Women team emerged as Runners-up in South Zone and All India
      Inter-University Tournaments.
    </li>
    <li>
      <strong>2018–2019:</strong> Handball Men team won Gold Medal in South Zone
      Inter-University Tournament hosted by Rayalaseema University.
    </li>
    <li>
      <strong>2016–2017:</strong> Sepak Takraw Men team secured Bronze Medal in
      All India Inter-University Championship.
    </li>
    <li>
      <strong>2014–2015:</strong> Taekwondo players won Gold & Bronze medals at
      All India Inter-University Championships.
    </li>
  </ul>
</div>


                    {/* ================= SPORTS INFRASTRUCTURE ================= */}
                    <div className="sports-facilities">
                        <h2><FaBuilding /> Sports Infrastructure Facilities</h2>

                        <ul>
                            <li>
                                Indoor Stadium with Floodlights and 03 Wooden Shuttle Badminton
                                Courts (Under Renovation)
                            </li>
                            <li>
                                Indoor Games Facilities: Carroms, Chess, and Table Tennis
                            </li>
                            <li>
                                400 meters Athletic Track with 8 Lanes
                            </li>
                            <li>
                                Two Volleyball Clay Courts
                            </li>
                            <li>
                                One Football Ground
                            </li>
                            <li>
                                One Cricket Ground
                            </li>
                            <li>
                                Well-equipped Gymnasium with:
                                <ul className="sub-list">
                                    <li>Ten Station Multi Gym</li>
                                    <li>Dumbbells, Barbells, and Weight Plates</li>
                                    <li>Multipurpose Bench Press</li>
                                    <li>Squat Stand and Flat Bench</li>
                                    <li>Dumbbell Rack and Barbell Rack</li>
                                </ul>
                            </li>
                        </ul>
                    </div>

                    {/* ================= IMAGE GALLERY ================= */}
                    <div className="sports-gallery">
                        <h2>Sports Activities Gallery</h2>

                        <div className="gallery-grid">
                            <img src="/campuslife/sports/sports1.jpeg" alt="Sports Activity 1" />
                            <img src="/campuslife/sports/sports2.jpeg" alt="Sports Activity 2" />
                            <img src="/campuslife/sports/sports4.jpeg" alt="Sports Activity 4" />
                            <img src="/campuslife/sports/sports6.jpeg" alt="Sports Activity 6" />
                            <img src="/campuslife/sports/sports7.jpeg" alt="Sports Activity 7" />
                            <img src="/campuslife/sports/sports8.jpeg" alt="Sports Activity 8" />
                            <img src="/campuslife/sports/sports9.jpeg" alt="Sports Activity 9" />
                            <img src="/campuslife/sports/sports10.jpeg" alt="Sports Activity 10" />
                            <img src="/campuslife/sports/sports12.jpeg" alt="Sports Activity 12" />
                            <img src="/campuslife/sports/sports13.jpeg" alt="Sports Activity 13" />
                            <img src="/campuslife/sports/sports14.jpeg" alt="Sports Activity 14" />
                            <img src="/campuslife/sports/sports18.jpeg" alt="Sports Activity 18" />
                            <img src="/campuslife/sports/sports19.jpeg" alt="Sports Activity 19" />
                            <img src="/campuslife/sports/sports26.jpeg" alt="Sports Activity 26" />
                            <img src="/campuslife/sports/sports27.jpeg" alt="Sports Activity 27" />
                        </div>
                    </div>

                </div>
            </section>
            <Footer />
        </>
    )
}

export default UniversitySports

